export default __webpack_public_path__ + "static/media/icon_close.9972202b.svg";